const EMAIL_TYPES = {
	MAIN: 'main',
	CC: 'cc',
};

export default EMAIL_TYPES;
